/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { SimpleFeesDto } from './SimpleFeesDto';
import {
    SimpleFeesDtoFromJSON,
    SimpleFeesDtoFromJSONTyped,
    SimpleFeesDtoToJSON,
    SimpleFeesDtoToJSONTyped,
} from './SimpleFeesDto';
import type { SimpleGuaranteeDto } from './SimpleGuaranteeDto';
import {
    SimpleGuaranteeDtoFromJSON,
    SimpleGuaranteeDtoFromJSONTyped,
    SimpleGuaranteeDtoToJSON,
    SimpleGuaranteeDtoToJSONTyped,
} from './SimpleGuaranteeDto';

/**
 * 
 * @export
 * @interface ContractualizationPricingDto
 */
export interface ContractualizationPricingDto {
    /**
     * List of guarantees
     * @type {Array<SimpleGuaranteeDto>}
     * @memberof ContractualizationPricingDto
     */
    guarantees: Array<SimpleGuaranteeDto>;
    /**
     * Total price excluding taxes
     * @type {number}
     * @memberof ContractualizationPricingDto
     */
    totalPriceHT: number;
    /**
     * Total price including taxes
     * @type {number}
     * @memberof ContractualizationPricingDto
     */
    totalPriceTTC: number;
    /**
     * Client price
     * @type {number}
     * @memberof ContractualizationPricingDto
     */
    clientPrice: number;
    /**
     * List of fees
     * @type {Array<SimpleFeesDto>}
     * @memberof ContractualizationPricingDto
     */
    fees: Array<SimpleFeesDto>;
    /**
     * Total fees including taxes
     * @type {number}
     * @memberof ContractualizationPricingDto
     */
    totalFeesTTC: number;
}

/**
 * Check if a given object implements the ContractualizationPricingDto interface.
 */
export function instanceOfContractualizationPricingDto(value: object): value is ContractualizationPricingDto {
    if (!('guarantees' in value) || value['guarantees'] === undefined) return false;
    if (!('totalPriceHT' in value) || value['totalPriceHT'] === undefined) return false;
    if (!('totalPriceTTC' in value) || value['totalPriceTTC'] === undefined) return false;
    if (!('clientPrice' in value) || value['clientPrice'] === undefined) return false;
    if (!('fees' in value) || value['fees'] === undefined) return false;
    if (!('totalFeesTTC' in value) || value['totalFeesTTC'] === undefined) return false;
    return true;
}

export function ContractualizationPricingDtoFromJSON(json: any): ContractualizationPricingDto {
    return ContractualizationPricingDtoFromJSONTyped(json, false);
}

export function ContractualizationPricingDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContractualizationPricingDto {
    if (json == null) {
        return json;
    }
    return {
        
        'guarantees': ((json['guarantees'] as Array<any>).map(SimpleGuaranteeDtoFromJSON)),
        'totalPriceHT': json['totalPriceHT'],
        'totalPriceTTC': json['totalPriceTTC'],
        'clientPrice': json['clientPrice'],
        'fees': ((json['fees'] as Array<any>).map(SimpleFeesDtoFromJSON)),
        'totalFeesTTC': json['totalFeesTTC'],
    };
}

export function ContractualizationPricingDtoToJSON(json: any): ContractualizationPricingDto {
    return ContractualizationPricingDtoToJSONTyped(json, false);
}

export function ContractualizationPricingDtoToJSONTyped(value?: ContractualizationPricingDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'guarantees': ((value['guarantees'] as Array<any>).map(SimpleGuaranteeDtoToJSON)),
        'totalPriceHT': value['totalPriceHT'],
        'totalPriceTTC': value['totalPriceTTC'],
        'clientPrice': value['clientPrice'],
        'fees': ((value['fees'] as Array<any>).map(SimpleFeesDtoToJSON)),
        'totalFeesTTC': value['totalFeesTTC'],
    };
}

